import styled from "styled-components";

import colors from "../../../assets/css/colors";

export const Container = styled.div`
    display: flex;
    margin-top: 60px;

    @media (max-width: 500px){
        display: block;
    }
`;

export const ButtonContainer = styled.div`
    width: 30%;

    @media (max-width: 1000px){
        width: 45%;
    }

    @media (max-width: 500px){
        width: 100%;
    }
`

export const EstablishmentSelected = styled.span`
    font: normal normal normal 16px Circular Std Book;
    margin-bottom: 24px;
    color: ${colors.primary};
`

export const TitleField = styled.h2`
    font: normal normal normal 16px Circular Std Book;
    margin-bottom: 24px;
    color: ${colors.tertiary};
`;

export const RowForInput = styled.div`
    display: flex;
    justify-content: space-between;
    width: 70%;
    margin-bottom: 43px;
    align-items: end;

    @media (max-width: 1000px){
        width: 100%;
    }

    @media (max-width: 500px){
        width: 100%;
        display: block;
        margin-bottom: 0px;
    }
`;

export const ColumnForTwoInputs = styled.div`
    width: 47%;

    @media (max-width: 500px){
        width: 100%;
    }
`;

export const RowForTwoInput = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;

    @media (max-width: 500px){
        display: block;
    }
`;

export const InputContainer = styled.div`
    width: 47%;
    position: relative;

    @media (max-width: 500px){
        width: 100%;
        margin-bottom: 30px;
    }
`;

export const MessageError = styled.span`
    position: absolute;
    color: ${colors.red};
    font-size: 12px;
    bottom: -18px;
    left: 0;
`

export const MessageErrorApi = styled.p`
    color: ${colors.red};
    font-size: 14px;
`

export const InputWithHintContainer = styled.div`
    display: flex;
    align-items: center;
`;